'use client'

import { Query } from '@/lib/generated/graphql-types'
import { SEARCH_SALARIES } from '@/modules/salary/queries'
import { useSuspenseQuery } from '@apollo/client'
import { useSearchParams } from 'next/navigation'
import { getSearchSalariesInput } from '@/modules/salary/common/get-search-salary-input'
import { useSalaryParams } from './use-salary-params'
import { useSalaryTableStore } from '@/modules/salary/salary-table-context'

export function useSalaries() {
  const { jobType, occupationSlug, location } = useSalaryParams()
  const hasInteractedWithRow = useSalaryTableStore(
    (state) => state.hasInteractedWithRow,
  )

  const searchParams = useSearchParams()
  const input = getSearchSalariesInput({
    jobType,
    occupationSlug,
    location,
    searchParams,
    hasInteractedWithRow,
  })

  const salaryResponse = useSuspenseQuery<Pick<Query, 'searchSalary'>>(
    SEARCH_SALARIES,
    {
      variables: {
        input,
      },
    },
  )
  return salaryResponse
}
